"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Ok {
    constructor(value) {
        this.value = value;
        this.kind = 'ok';
    }
    then(f) {
        return f(this.value);
    }
    map(f) {
        return asResult(() => f(this.value));
    }
    unwrap() {
        return this.value;
    }
}
class Error {
    constructor(message) {
        this.message = message;
        this.kind = 'error';
    }
    then(f) {
        return error(this.message);
    }
    map(f) {
        return error(this.message);
    }
    unwrap() {
        throw new Error(this.message);
    }
}
function ok(v) {
    return new Ok(v);
}
exports.ok = ok;
function error(message) {
    return new Error(message);
}
exports.error = error;
function asResult(f) {
    try {
        return ok(f());
    }
    catch (exn) {
        return error(exn.toString());
    }
}
exports.asResult = asResult;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzdWx0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vdHMvcmVzdWx0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsTUFBTSxFQUFFO0lBRUosWUFBbUIsS0FBUTtRQUFSLFVBQUssR0FBTCxLQUFLLENBQUc7UUFEcEIsU0FBSSxHQUFTLElBQUksQ0FBQztJQUV6QixDQUFDO0lBRUQsSUFBSSxDQUFJLENBQXNCO1FBQzFCLE9BQU8sQ0FBQyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQztJQUN6QixDQUFDO0lBRUQsR0FBRyxDQUFJLENBQWM7UUFDakIsT0FBTyxRQUFRLENBQUMsR0FBRyxFQUFFLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDO0lBQ3pDLENBQUM7SUFFRCxNQUFNO1FBQ0YsT0FBTyxJQUFJLENBQUMsS0FBSyxDQUFDO0lBQ3RCLENBQUM7Q0FDSjtBQUVELE1BQU0sS0FBSztJQUVQLFlBQW1CLE9BQWU7UUFBZixZQUFPLEdBQVAsT0FBTyxDQUFRO1FBRDNCLFNBQUksR0FBWSxPQUFPLENBQUM7SUFFL0IsQ0FBQztJQUVELElBQUksQ0FBSSxDQUFzQjtRQUMxQixPQUFPLEtBQUssQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLENBQUM7SUFDL0IsQ0FBQztJQUVELEdBQUcsQ0FBSSxDQUFjO1FBQ2pCLE9BQU8sS0FBSyxDQUFDLElBQUksQ0FBQyxPQUFPLENBQUMsQ0FBQztJQUMvQixDQUFDO0lBRUQsTUFBTTtRQUNGLE1BQU0sSUFBSSxLQUFLLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxDQUFDO0lBQ2xDLENBQUM7Q0FDSjtBQUVELFNBQWdCLEVBQUUsQ0FBSSxDQUFJO0lBQ3RCLE9BQU8sSUFBSSxFQUFFLENBQUMsQ0FBQyxDQUFDLENBQUM7QUFDckIsQ0FBQztBQUZELGdCQUVDO0FBRUQsU0FBZ0IsS0FBSyxDQUFJLE9BQWU7SUFDcEMsT0FBTyxJQUFJLEtBQUssQ0FBQyxPQUFPLENBQUMsQ0FBQztBQUM5QixDQUFDO0FBRkQsc0JBRUM7QUFFRCxTQUFnQixRQUFRLENBQUksQ0FBVTtJQUNsQyxJQUFJO1FBQ0EsT0FBTyxFQUFFLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQztLQUNsQjtJQUNELE9BQU8sR0FBRyxFQUFFO1FBQ1IsT0FBTyxLQUFLLENBQUMsR0FBRyxDQUFDLFFBQVEsRUFBRSxDQUFDLENBQUM7S0FDaEM7QUFDTCxDQUFDO0FBUEQsNEJBT0MifQ==


//////////////////
// WEBPACK FOOTER
// ../util/dist/ts/result.js
// module id = 785
// module chunks = 0